"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsComponent = void 0;
var core_1 = require("@angular/core");
var _services_1 = require("@/_services");
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(authenticationService, userService) {
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.display = 'none';
        this.currentUser = this.authenticationService.currentUserValue;
    }
    NotificationsComponent.prototype.ngOnInit = function () {
    };
    NotificationsComponent.prototype.openModal = function () {
        this.display = "block";
    };
    NotificationsComponent = __decorate([
        core_1.Component({
            selector: 'app-notifications',
            template: require('./notifications.component.html')
        }),
        __metadata("design:paramtypes", [_services_1.AuthenticationService, _services_1.UserService])
    ], NotificationsComponent);
    return NotificationsComponent;
}());
exports.NotificationsComponent = NotificationsComponent;
